import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArchiveJunk: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"archive-junk"} maskId="square-filled-radius-0-stroke-1-IconArchiveJunk"><path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V8H21V21ZM12 13.793L9.85352 11.6465L9.14648 12.3535L11.293 14.5L9.14648 16.6465L9.85352 17.3535L12 15.207L14.1465 17.3535L14.8535 16.6465L12.707 14.5L14.8535 12.3535L14.1465 11.6465L12 13.793Z" fill="currentColor"/><path d="M22 7H2V3H22V7Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArchiveJunk;
